import React from "react";
import { Link, Divider } from "@heroui/react";
import { Icon } from "@iconify/react";

import { Link as RouterLink } from "react-router-dom";
import footerLogo from '../assets/logos/footer-logo-old.png';
import IconVK from '../assets/icon/vk.svg';

interface FooterProps {
  currentPage: string;
  onPageChange: (page: string) => void;
}

export const Footer: React.FC<FooterProps> = ({ currentPage, onPageChange }) => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-content3 py-16" id="contacts">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            {/* <RouterLink to="/" className="text-xl font-bold mb-6 tracking-widest block">ANNA SAFONOVA</RouterLink> */}
            {/* Footer logo above description — adaptive width and theme-aware inversion */}
            <Link href="/" className="text-xl font-bold tracking-widest block">
              <img src={footerLogo} alt="SAFONOVA" className="w-full h-auto object-contain footer-logo" />
            </Link>
            <p className="text-foreground/70 mb-6">
              Премиальные ароматические продукты ручной работы для создания особой атмосферы в вашем доме и бизнесе.
            </p>
          </div>

          <div>
            <h4 className="text-lg font-medium mb-6">Продукция</h4>
            <ul className="space-y-3">
              {/* <li>
                <RouterLink 
                  to="/gift-card" 
                  className="text-foreground/70 hover:text-foreground"
                >
                  Подарочные карты
                </RouterLink>
              </li> */}
              <li>
                <RouterLink 
                  to="/product/candles" 
                  className="text-foreground/70 hover:text-foreground"
                >
                  Ароматические свечи
                </RouterLink>
              </li>
              <li>
                <RouterLink 
                  to="/product/massage_candles" 
                  className="text-foreground/70 hover:text-foreground"
                >
                  Массажные свечи
                </RouterLink>
              </li>
              {/* <li>
                <RouterLink 
                  to="/product/table_candles" 
                  className="text-foreground/70 hover:text-foreground"
                >
                  Столовые свечи
                </RouterLink>
              </li> */}
              <li>
                <RouterLink 
                  to="/product/decorative_candles" 
                  className="text-foreground/70 hover:text-foreground"
                >
                  Декоративные свечи
                </RouterLink>
              </li>
              <li>
                <RouterLink 
                  to="/product/auto_perfumes" 
                  className="text-foreground/70 hover:text-foreground"
                >
                  Автопарфюм
                </RouterLink>
              </li>        
              <li>
                <RouterLink 
                  to="/product/diffusers" 
                  className="text-foreground/70 hover:text-foreground"
                >
                  Диффузоры
                </RouterLink>
              </li>
              <li>
                <RouterLink 
                  to="/product/sachets" 
                  className="text-foreground/70 hover:text-foreground"
                >
                  Саше
                </RouterLink>
              </li>
              {/* <li>
                <RouterLink 
                  to="/product/melts" 
                  className="text-foreground/70 hover:text-foreground"
                >
                  Мелтсы
                </RouterLink>
              </li> */}
              {/* <li>
                <RouterLink 
                  to="/product/gift_sets" 
                  className="text-foreground/70 hover:text-foreground"
                >
                  Подарочные наборы
                </RouterLink>
              </li> */}

            </ul>
          </div>

          <div>
            <h4 className="text-lg font-medium mb-6">Информация</h4>
            <ul className="space-y-3">
              <li>
                <RouterLink 
                  to="/about" 
                  className="text-foreground/70 hover:text-foreground"
                >
                  О нас
                </RouterLink>
              </li>
              <li>
                <RouterLink 
                  to="/partners" 
                  className="text-foreground/70 hover:text-foreground"
                >
                  Партнерам
                </RouterLink>
              </li>
              <li>
                <RouterLink 
                  to="/news-list" 
                  className="text-foreground/70 hover:text-foreground"
                >
                  Новости
                </RouterLink>
              </li>
              <li>
                <RouterLink 
                  to="/store-addresses" 
                  className="text-foreground/70 hover:text-foreground"
                >
                  Торговые точки
                </RouterLink>
              </li>
              {/* <li>
                <RouterLink 
                  to="/auth" 
                  className="text-foreground/70 hover:text-foreground"
                >
                  Вход / Регистрация
                </RouterLink>
              </li> */}
              <li>
                <RouterLink 
                  to="/account" 
                  className="text-foreground/70 hover:text-foreground"
                >
                  Личный кабинет
                </RouterLink>
              </li>
              <li>
                <RouterLink 
                  to="/shipping" 
                  className="text-foreground/70 hover:text-foreground"
                >
                  Доставка и оплата
                </RouterLink>
              </li>
              <li>
                <RouterLink 
                  to="/returns" 
                  className="text-foreground/70 hover:text-foreground"
                >
                  Возврат и обмен
                </RouterLink>
              </li>
              {/* <li>
                <RouterLink 
                  to="/privacy" 
                  className="text-foreground/70 hover:text-foreground"
                >
                  Политика конфиденциальности
                </RouterLink>
              </li>
              <li>
                <RouterLink 
                  to="/terms" 
                  className="text-foreground/70 hover:text-foreground"
                >
                  Публичная оферта
                </RouterLink>
              </li> */}
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-medium mb-6">Контакты</h4>
            <ul className="space-y-4">
              {/* <li className="flex items-start gap-3">
                <Icon icon="lucide:map-pin" className="text-primary mt-1" width={18} />
                <span className="text-foreground/70">г. Москва, ул. Арбат, 10, офис 205</span>
              </li> */}
              <li className="flex items-start gap-3">
                <Icon icon="lucide:phone" className="text-primary mt-1" width={18} />
                <span className="text-foreground/70">+7 (995) 881-02-47</span>
              </li>
              <li className="flex items-start gap-3">
                <Icon icon="lucide:mail" className="text-primary mt-1" width={18} />
                <Link 
                  href="mailto:info@safonova-brand.ru" 
                  className="text-foreground/70 hover:text-foreground relative group overflow-hidden"
                >
                  <span className="transition-colors duration-300 ease-out">info@safonova-brand.ru</span>
                  <span className="absolute left-0 bottom-0 w-0 h-px bg-foreground transition-all duration-300 ease-in-out group-hover:w-full"></span>
                </Link>
              </li>
              {/* <li className="flex items-start gap-3">
                <Icon icon="lucide:clock" className="text-primary mt-1" width={18} />
                <span className="text-foreground/70">Пн-Пт: 10:00 - 19:00<br />Сб: 11:00 - 17:00</span>
              </li> */}
            </ul>
            <div className="mt-6">
              <h4 className="text-lg font-medium mb-6">Мы в соцсетях</h4>
              <div className="flex items-center gap-4">
                <a
                  href="https://t.me/safonova_handmade"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-foreground/70 hover:text-foreground transition-colors duration-200"
                  aria-label="Telegram"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="icon icon-tabler icons-tabler-outline icon-tabler-brand-telegram">
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                    <path d="M15 10l-4 4l6 6l4 -16l-18 7l4 2l2 6l3 -4" />
                  </svg>
                </a>

                <a
                  href="https://vk.com/id883290794"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-foreground/70 hover:text-foreground transition-colors duration-200"
                  aria-label="VK"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="icon icon-tabler icons-tabler-outline icon-tabler-brand-vk">
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                    <path d="M14 19h-4a8 8 0 0 1 -8 -8v-5h4v5a4 4 0 0 0 4 4h0v-9h4v4.5l.03 0a4.531 4.531 0 0 0 3.97 -4.496h4l-.342 1.711a6.858 6.858 0 0 1 -3.658 4.789h0a5.34 5.34 0 0 1 3.566 4.111l.434 2.389h0h-4a4.531 4.531 0 0 0 -3.97 -4.496v4.5z" />
                  </svg>
                </a>

                <a
                  href="https://youtube.com/@safonova__aroma_brand?si=SMqFCS8bGqhvrHDL"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-foreground/70 hover:text-foreground transition-colors duration-200"
                  aria-label="YouTube"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="icon icon-tabler icons-tabler-outline icon-tabler-brand-youtube">
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                    <path d="M2 8a4 4 0 0 1 4 -4h12a4 4 0 0 1 4 4v8a4 4 0 0 1 -4 4h-12a4 4 0 0 1 -4 -4v-8z" />
                    <path d="M10 9l5 3l-5 3z" />
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>

        <Divider className="my-10" />

        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="text-foreground/60 text-sm">
            <p className="mb-1">
              © {currentYear} SAFONOVA. Все права защищены.
            </p>
            <p className="mb-1">ИП Сафонова Анна Сергеевна</p>
            <p className="mb-1">ИНН: 773618853593</p>
            <p>ОГРНИП: 324774600132375</p>
            {/* Ненавязчивое сообщение об ошибках — мелкий и полупрозрачный текст */}
            <p className="text-xs text-foreground/40 mt-2">
              Нашли ошибку? Сообщите нам —
              <a
                href="mailto:info@safonova-brand.ru"
                className="ml-1 underline hover:text-foreground transition-colors duration-150"
              >
                info@safonova-brand.ru
              </a>
            </p>
          </div>
          <div className="flex gap-6 mt-4 md:mt-0">
             <RouterLink 
              to="/privacy" 
              className="text-foreground/60 text-sm hover:text-foreground"
              >
                Политика конфиденциальности
            </RouterLink>
            <RouterLink 
              to="/terms" 
              className="text-foreground/60 text-sm hover:text-foreground"
              >
                Публичная оферта
            </RouterLink>
            {/* <Link href="#" className="text-foreground/60 text-sm hover:text-foreground">
              Политика конфиденциальности
            </Link> */}
            {/* <Link href="#" className="text-foreground/60 text-sm hover:text-foreground">
              Условия использования
            </Link> */}
          </div>
        </div>
      </div>
    </footer>
  );
};